/**
 * Document types supported by the document download API
 * 
 * DOCUMENT DOWNLOAD PARENT ID MAPPING:
 * =====================================
 * Each document type requires a specific parentId type:
 * 
 * Property Documents (require salesorderid):
 * - SALES_SOA (Account statement) → salesorderid
 * - SALES_RECEIPT (Receipt history) → salesorderid
 * - TITLE_DEED → salesorderid
 * - SPA → salesorderid
 * 
 * Identity Documents (use customer id only, no parentId required):
 * - PASSPORT → customer id (no parentId needed)
 * - EID_FRONT → customer id (no parentId needed)
 * - EID_BACK → customer id (no parentId needed)
 * 
 * Invoice Documents (require installment id):
 * - SALES_INVOICE → installment id
 * - SALES_PORFORMA_INVOICE → installment id
 * 
 * Unit Documents (require unit id):
 * - FLOOR_PLAN → unit id
 * 
 * Not in Scope:
 * - COMMUNITY_SOA → not in scope
 * - COMMUNITY_RECEIPT → not in scope
 */
export const DOCUMENT_TYPES = {
    SALES_SOA: 'SALES_SOA',
    SALES_RECEIPT: 'SALES_RECEIPT',
    TITLE_DEED: 'TITLE_DEED',
    COMMUNITY_SOA: 'COMMUNITY_SOA',
    COMMUNITY_RECEIPT: 'COMMUNITY_RECEIPT',
    PASSPORT: 'PASSPORT',
    EID_FRONT: 'EID_FRONT',
    EID_BACK: 'EID_BACK',
    SALES_INVOICE: 'SALES_INVOICE',
    SALES_PORFORMA_INVOICE: 'SALES_PORFORMA_INVOICE',
    FLOOR_PLAN: 'FLOOR_PLAN',
    SPA: 'SPA',
} as const;

export const DOCUMENT_SF_NAMES = {
    TITLE_DEED: 'Title Deed',
    FLOOR_PLAN: 'Floor Plan',
    SPA: 'SPA - Signed',
    PASSPORT: 'Passport',
    EID_FRONT: 'Emirates ID Front',
    EID_BACK: 'Emirates ID Back',

    // real time generation documents. cant be mapped
    // SALES_SOA: 'SALES_SOA',
    // SALES_RECEIPT: 'SALES_RECEIPT',
    // SALES_INVOICE: 'SALES_INVOICE',
    // SALES_PORFORMA_INVOICE: 'SALES_PORFORMA_INVOICE',

} as const;

export type DocumentType = typeof DOCUMENT_TYPES[keyof typeof DOCUMENT_TYPES];
export type DocumentSFName = typeof DOCUMENT_SF_NAMES[keyof typeof DOCUMENT_SF_NAMES];
export type PropertyDocument = [ { docId: string , name : DocumentSFName}];

